// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Universe Improbability Sector - Main Export
 * 
 * Where the Infinite Improbability Drive went horribly right.
 * A universe of absurdity, philosophy, and towels.
 */

import { starSystems, spaceStations } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { ImprobabilityAliensPlanets } from './AliensConfig';

// Star system positions on the 3D map
const starPositions = {
  // Starting system - center
  300: { x: 50, y: 50, z: 0 },   // MAGRATHEA
  
  // Inner ring - close systems
  301: { x: 35, y: 35, z: -10 }, // BETELGEUSE SEVEN
  302: { x: 65, y: 35, z: 10 },  // FROGSTAR WORLD B
  303: { x: 70, y: 60, z: -15 }, // MILLIWAYS
  
  // Middle ring - medium distance
  304: { x: 25, y: 65, z: 20 },  // DAMOGRAN
  305: { x: 75, y: 75, z: -20 }, // KAKRAFOON
  306: { x: 30, y: 25, z: 15 },  // URSA MINOR BETA
  
  // Outer ring - far systems
  307: { x: 80, y: 30, z: 25 },  // SQORNSHELLOUS ZETA
  308: { x: 20, y: 80, z: -25 }, // PRELIUMTARN
  309: { x: 85, y: 85, z: 30 },  // BARTLEDAN
};

// Space station positions on the 3D map
const stationPositions = {
  400: { x: 45, y: 40, z: 5 },   // DEEP THOUGHT STATION
  401: { x: 60, y: 55, z: -5 },  // HEART OF GOLD DEPOT
  402: { x: 40, y: 70, z: 12 },  // SIRIUS CYBERNETICS OUTPOST
  403: { x: 75, y: 45, z: -12 }, // GOLGAFRINCHAN ARK STATION
};

export const universeImprobability = {
  id: 'improbability',
  starSystems,
  spaceStations,
  starPositions,
  stationPositions,
  warpGates,
  warpGatePositions,
  aliens: ImprobabilityAliensPlanets,
};

export default universeImprobability;
